/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment'; // Importa el environment adecuado

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(public authService: AuthService, public router: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('Authorization');
    const excludedUrls = ['assets/i18n/sp.json',
      'assets/i18n/en.json',
      `${environment.apiroot}/auth/register`,
    ];

    // Verificar si la URL está excluida
    const isExcluded = excludedUrls.some(url => request.url.includes(url));

    let tokenizedReq = request;

    if (!isExcluded) {
      if (token !== null) {
        // Si hay un token, agrégalo al header
        tokenizedReq = request.clone({ setHeaders: { 'app-version': '1.0.0', Authorization: token } });
      } else {
        // Si no hay token, redirigir al login
        this.router.navigateByUrl('/account-login');
      }
    } else {
      // Para las URLs excluidas, solo agregar el header común
      tokenizedReq = request.clone({ setHeaders: { 'app-version': '1.0.0' } });
    }
    return next.handle(tokenizedReq);
  }

}